<template>
    <!-- 买家用 -->
    <div class="content">
        <div style="font-size:15px;">{{circleContent}}</div>
        <!-- <div v-if="content" class="title">
            <div class="title-text">
                <span>喜悦圈子公约</span>
            </div>
        </div> -->
        <div v-if="content" v-html="content"></div>
    </div>
</template>

<script>
import { getTypeAndsw,getActivityRuleContent } from "@/api/join";
export default {
    data() {
        return {
            circleContent: "",
            content:'',
        };
    },
    methods: {
        async getRule(){
            const circleRes = await getTypeAndsw({
                expertId:this.$route.query.expertId
            })
            if(circleRes.appStatus.errorCode == 0){
                this.circleContent = circleRes.content.note;
            }
            const ruleRes = await getActivityRuleContent({type:61})
            if(ruleRes.appStatus.errorCode == 0){
                this.content = ruleRes.content.content
            }
        }
    },
    mounted() {
        this.getRule()
    },
};
</script>
<style lang='scss' scoped>
    .content{
        padding: 20px;
        .title-text span {
            display: block;      /*设置为块级元素会独占一行形成上下居中的效果*/
            position: relative;  /*定位横线（当横线的父元素）*/
            // color: #188eee;      /*居中文字的颜色*/
            text-align: center; 
            margin: 30px 0;
            font-size: 16px;
        } 

        .title-text span:before, .title-text span:after { 
            content: ''; 
            position: absolute;   /*定位背景横线的位置*/
            top: 50%; 
            background: #8c8c8c;   /*背景横线颜色*/
            width: 35%;            /*单侧横线的长度*/
            height: 1px; 
        } 

        .title-text span:before { 
            left: 2%;              /*调整背景横线的左右距离*/
        } 

        .title-text span:after { 
            right: 2%; 
        }
        
    }
</style>